export default __webpack_public_path__ + "static/media/logo_small.7c9642e9.svg";